module.exports = __webpack_public_path__ + "static/media/plus-green.54d2bc2b.svg";